import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { runBatchLoader } from "utils/batchLoader";
import MetaTags from "react-meta-tags";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row
} from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import Datatable from "components/Datatables/datatable";
import { post } from "helpers/api_helper";
import "react-datepicker/dist/react-datepicker.css";
import { Filters } from "../filters";
import Maincard from "../components/maincard";
import moment from "moment";
import { Link } from "react-router-dom";
import { filter } from "lodash";

const isType = 'Proforma Invoices';

const Proforma = () => {
    const [rowData, setRowData] = useState([])
    const [filterData, setFilterData] = useState({})
    const [isLoading, setIsLoading] = useState(true)
    const [pagination, setPagination] = useState({
        limit: 10,
        page: 1,
        search: ''
    })
    const [batchProgress, setBatchProgress] = useState(null)
    const batchCancelRef = useRef(false)
    const isBatchRunningRef = useRef(false)
    const totalRowsRef = useRef(0)

    useEffect(() => {
        if (rowData?.total_rows) {
            totalRowsRef.current = rowData.total_rows
        }
    }, [rowData])

    const handleCancelBatch = () => {
        batchCancelRef.current = true
        isBatchRunningRef.current = false
        setBatchProgress(prev => prev ? ({ ...prev, active: false, stopped: true }) : null)
        setIsLoading(false)
    }

    const handlePaginationChange = useCallback((newPag) => {
        setPagination(prev => {
            if (
                prev.page === newPag.page &&
                prev.limit === newPag.limit &&
                prev.search === newPag.search &&
                Boolean(prev.isAll) === Boolean(newPag.isAll)
            ) {
                return prev
            }
            return { ...prev, ...newPag }
        })
    }, [])

    // table Column Data
    let tableColumns = [
        {
            dataField: 'invoice_number',
            text: 'Invoice Number',
        },{
            dataField: 'invoice_date',
            text: 'Invoice Date',
            // formatter: (cell, row) => moment(row.invoice_date).format('DD-MM-YYYY')
        },{
            dataField: 'clientname',
            text: 'Client',
            sort: true
        },{
            dataField: 'city',
            text: 'City',
            formatter: (cell, row) => row.city ? row.city : '-',
            csvFormatter: (cell, row) => row.city? row.city : '-'
        },{
            dataField: 'Proforma',
            text: 'Proforma',
            sort: true,
            formatter: (cell, row) => row.is_lock == 1? "Invoice Genarted": "Pending",
            csvFormatter: (cell, row) => row.is_lock == 1? "Invoice Genarted": "Pending"
        },{
            dataField: 'is_lock',
            dataField: 'is_lock',
            text: 'Status', //invoice_status
            formatter: (cell, row) => row.status == 1? "Cancled": "Active",
            csvFormatter: (cell, row) => row.status == 1? "Cancled": "Active"
        },{
            dataField: 'invoice_total',
            text: 'Sub Total',
            sort: true,
            formatter: (cell, row) => `₹ ${parseFloat(row.invoice_total).toFixed(2)}`,
            csvFormatter: (cell, row) => parseFloat(row.invoice_total).toFixed(2),
        },{
            dataField: 'GST',
            text: '	GST (5%)',
            sort: true,
            dummyField: true,
            formatter: (cell, row) => `₹ ${(parseFloat(row.invoice_total) * 0.05).toFixed(2)}`,
            csvFormatter: (cell, row) => (parseFloat(row.invoice_total) * 0.05).toFixed(2),
        },{
            dataField: 'amount',
            text: '	Invoice Amount',
            dummyField: true,
            sort: true,
            formatter: (cell, row) => `₹ ${(parseFloat(row.invoice_total) + (parseFloat(row.invoice_total) * 0.05)).toFixed(2)}`,
            csvFormatter: (cell, row) => (parseFloat(row.invoice_total) + (parseFloat(row.invoice_total) * 0.05)).toFixed(2),
        },{
            dataField: 'Actions',
            text: '	Invoice Amount',
            dummyField: true,
            csvExport: false,
            formatter: (cell, row) => <Link to="#" className="ms-1 btn btn-outline-danger btn-sm" onClick={() => {
                window.open(`/invoice/print?invoice_number=${row?.proforma_invoice_number}&type=proforma`, '_blank');
            }} title="View proforma invoice" ><i className="fas fa-eye" /></Link>
        }
    ];

    const lastQueryRef = useRef('');

    const filterOptions = useMemo(() => ({
        order_type: false,
        city: true,
        client: true,
        dates: true,
        category: false,
        p_type: false,
        product: false
    }), []);

    const submitCall = async (filters = filterData) => {
        if(Object.keys(filters)?.length == 0) return;
        const isAllSelected = pagination?.isAll || pagination?.limit === 'all' || (typeof pagination?.limit === 'number' && pagination?.limit > 100);

        if (isAllSelected) {
            lastQueryRef.current = '';
            batchCancelRef.current = true;
            await new Promise(r => setTimeout(r, 60));
            batchCancelRef.current = false;
            isBatchRunningRef.current = true;

            setIsLoading(true);
            try {
                await runBatchLoader({
                    fetchPage: async (page, batchSize) => {
                        const queryParams = new URLSearchParams({
                            type: 'Proforma',
                            searchTerm: pagination?.search || '',
                            limit: batchSize,
                            page: page,
                        }).toString();
                        const { status, response } = await post(`api/reports/invoices?${queryParams}`, filters);
                        return status === 200 ? response : {};
                    },
                    batchSize: 100,
                    initialTotal: totalRowsRef.current || 0,
                    onProgress: setBatchProgress,
                    onRowsLoaded: (accumulatedRows, totalCount) => {
                        setRowData({
                            total_rows: totalCount,
                            rows: accumulatedRows
                        });
                    },
                    cancelRef: batchCancelRef,
                    runningRef: isBatchRunningRef,
                });
            } catch (err) {
                console.error("Error batch loading proforma invoices:", err);
            } finally {
                setIsLoading(false);
            }
        } else {
            const queryParams = new URLSearchParams({
                type: 'Proforma',
                searchTerm: pagination?.search || '',
                limit: pagination?.limit,
                page: pagination?.page,
            }).toString();
            const requestKey = `${queryParams}_${JSON.stringify(filters)}`;
            if (lastQueryRef.current === requestKey) return;
            lastQueryRef.current = requestKey;

            setIsLoading(true);
            setBatchProgress(null);
            try {
                const { status, response } = await post(`api/reports/invoices?${queryParams}`, filters);
                if (status === 200) {
                    setRowData(response);
                }
            } catch (err) {
                console.error("Error loading proforma invoices:", err);
            } finally {
                setIsLoading(false);
            }
        }
    };

    useEffect(() => {
        submitCall();
    }, [filterData, pagination]);


    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags> <title>Dashboard | {isType}</title> </MetaTags>
                <Container fluid>
                    <Breadcrumbs title="Reports" breadcrumbItem={isType} />
                    <Filters callback={setFilterData} filterOptions={filterOptions} />

                    {/* <Maincard cardItems={rowData?.dataCount} loading={isLoading}/> */}

                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    <Datatable
                                        keyField={'invoice_number'}
                                        filename={`Proforma_Invoices - ${moment().format('DDMMYYYYHHmmSS')}`}
                                        title={``}
                                        isAdd={false}
                                        handleAddButton=''
                                        isSearch={true}
                                        isExport={true}
                                        columns={tableColumns}
                                        rowsLength={rowData?.total_rows || (Array.isArray(rowData) ? rowData.length : 0)}
                                        rows={rowData?.rows || (Array.isArray(rowData) ? rowData : [])}
                                        isTableHead={true}
                                        loading={isLoading && (!batchProgress || batchProgress.loaded === 0)}
                                        batchProgress={batchProgress}
                                        onCancelBatch={handleCancelBatch}
                                        batchSize={100}
                                        is_remote={true}
                                        ssr={handlePaginationChange}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Proforma
